import request from '@/util/request';

//集团知识库目录树-懒加载
export const getKnowledgeGroupMenu = (params, options) =>
  request.get('/api/v4ward/knowledgeGroupMenu/lazyTree', Object.assign({}, options, { params }));
  //集团知识库目录树-非懒加载
  export const getKnowledgeGroupMenu2 = (params, options) =>
  request.get('/api/v4ward/knowledgeGroupMenu/tree', Object.assign({}, options, { params }));
//集团知识库目录-保存
export const saveKnowledgeGroupMenu = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupMenu/save', data, options);
//集团知识库目录-更新
export const updateKnowledgeGroupMenu = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupMenu/update', data, options);
//集团知识库目录-删除
export const removeKnowledgeGroupMenu = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupMenu/remove', data, options);

//集团知识库文件-分页列表
export const knowledgeGroupPage = (params, options) =>
  request.get('/api/v4ward/knowledgeGroupFile/page', Object.assign({}, options, { params }));
//集团知识库文件-保存
export const saveKnowledgeGroup = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupFile/save', data, options);
//集团知识库文件-删除
export const delKnowledgeGroup = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupFile/remove', data, options);
//集团知识库文件-编辑详情
export const getKnowledgeGroupSelectById = (params, options) =>
  request.get('/api/v4ward/knowledgeGroupFile/selectById', Object.assign({}, options, { params }));
//集团知识库文件-预览详情
// export const getKnowledgeGroupDetail = (params, options) =>
//   request.get('/api/v4ward/knowledgeGroupFile/detail', Object.assign({}, options, { params }));
//集团知识库文件-更新
  export const updateKnowledgeGroup = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupFile/update', data, options);

  export const viewKnowledgeGroup = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupFile/view', data, options);

  export const getKnowledgeGroupFileRecommendPage = (params, options) =>
  request.get('/api/v4ward/knowledgeGroupFileRecommend/page', Object.assign({}, options, { params }));

  export const noAdopt = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupFileRecommend/noAdopt', data, options);

  export const adopt = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupFileRecommend/adopt', data, options);

  export const getDept = (params, options) =>
  request.get('/api/v4ward/knowledgeGroupFile/getDept', Object.assign({}, options, { params }));
 //下载量 +1
  export const groupDownload = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupFile/download', data, options);


